/**************************************************
 * Nombre:       Producto_Especificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Producto_Especificaciones = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: sCell ? 24 : 30, fontWeight: 600, px: 1}}>Especificaciones</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 18, fontWeight: 400, px: 1}}>Vick Fort-9 es un tratamiento sintomático del
                    resfriado
                    común y provee alivio contra los síntomas de la gripa como: fiebre, dolor de cabeza, dolor de
                    garganta, dolor muscular, ojos llorosos, congestión nasal, secreción nasal, estornudos,
                    escalofríos.</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Typography sx={{fontSize: 22, fontWeight: 600, backgroundColor: '#E6E6FF', px: 1, width: '100%'}}>Caracteristicas
                    del
                    producto</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{px: 1}}
                    spacing={1}>

                    {items.map((item, index) => (
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}

                        >

                            <Grid container size={{xs: 6, sm: 6, md: 6}}
                                  sx={{
                                      backgroundColor: index % 2 === 0 ? '#fff' : '#E6E6FF',
                                      px: 1,
                                      justifyContent: 'flex-start'
                                  }}
                            >
                                <Typography>{item.nombre}</Typography>
                            </Grid>

                            <Grid container size={{xs: 6, sm: 6, md: 6}}
                                  sx={{
                                      backgroundColor: index % 2 === 0 ? '#fff' : '#E6E6FF',
                                      px: 1,
                                      justifyContent: 'flex-end'
                                  }}
                            >
                                <Typography sx={{textAlign: 'rigth'}}>{item.descripcion}</Typography>
                            </Grid>


                        </Grid>

                    ))}

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Producto_Especificaciones

const items = [
    {
        nombre: 'Registro Sanitario',
        descripcion: '2021M-0017022-R1'
    },
    {
        nombre: 'NSO',
        descripcion: 'N/A'
    },
    {
        nombre: 'ISTK',
        descripcion: '24654'
    },

]